module.exports = __webpack_public_path__ + "static/img/fish12.9b484ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish12.png
// module id = S/2t
// module chunks = 0